import HttpHelper from "../../../helpers/httpHelper";
import { getHeaderDetail } from "../../../helpers/utility";

const STREAMING_API_URL = process.env.REACT_APP_STREAMING_API_URL;

class StreamingAPI {
    static getAppToken(req) {
        let url = `${STREAMING_API_URL}/appToken?room_id=${req.room_id}&user_id=${req.user_id}&role=${req.role}`;
        return HttpHelper.httpRequest(url, "GET", {});
    }

    static startRecording(req) {
        let url = `${STREAMING_API_URL}/record/start?room_id=${req}`;
        return fetch(url, {
            method: "POST",
            headers: getHeaderDetail({})
        });
    }

    static stopRecording(req) {
        let url = `${STREAMING_API_URL}/record/stop?room_id=${req}`;
        return HttpHelper.httpRequest(url, "POST", {});
    }

    static createNewRoom(req) {
        let url = `${STREAMING_API_URL}/room/${req.name}?description=${req.description}`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    static getSessions(req) {
        let url = `${STREAMING_API_URL}/sessions?room_id=${req}&id=627021969bab8da58de6cdbd`;
        return HttpHelper.httpRequest(url, "GET", {});
    }

    static getLastSessions(req) {
        let url = `${STREAMING_API_URL}/last?room_id=${req}&active=true`;
        return HttpHelper.httpRequest(url, "GET", {});
    }
}

export default StreamingAPI;
